//
//
//
//
//
//
//
import prowerSelect from "./prowerSelect.vue";
import { MESSAGE } from '@/util/elementHandle';
export default {
  data: function data() {
    return {
      tagsList: [],
      childSelect: '',
      inheritAttrs: false,
      linkbreak: true
    };
  },
  props: ['list'],
  components: {
    prowerSelect: prowerSelect
  },
  watch: {
    list: function list(newVal) {//  console.log(newVal,'list---')
    }
  },
  methods: {
    treeSettingHandle: function treeSettingHandle(data) {
      this.childSelect = 'aaaa';
    }
  },
  mounted: function mounted() {}
};